import TranslationSimple from './translation_simple';

export default class TranslationJob extends TranslationSimple {
  constructor(rootElementId) {
    super(rootElementId);
    this.updateAllExtraOptions();
  }

  handleLanguageCheckboxToggle(ev) {

    if(!this.checkboxIsChecked('en') && !this.checkboxIsChecked('ja')){
      ev.preventDefault();
      ev.stopPropagation();
      $(ev.target).prop('checked', true);
      this.showAlert();
      return false;
    }

    this.updateAllExtraOptions();

    // Continue with parent method
    TranslationSimple.prototype.handleLanguageCheckboxToggle.call(this);
  }

  updateAllExtraOptions(){
    ['ja', 'en'].forEach(lang => {
      const enabled = this.shouldEnableInput(lang);
      this.$scope.find(`[data-button-type=extra-option][data-lang=${lang}]`).attr("disabled", !enabled);
    });
  }

  showAlert(){
    alert(gon.views.shared.select_at_least_one_language);
  }
}
